// Centralized configuration for the application
const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL
        ? `${process.env.REACT_APP_API_BASE_URL}/api/v1`
        : window.location.hostname === 'localhost'
            ? '/api/v1'
            : `${window.location.origin}/api/v1`
};
export default config;
// force rebuild 2026-02-20 14:22
